import { clsx } from 'clsx'
import styles from './VideoLabel.module.scss'
import { Icon } from '@/components/Icon'
import React from 'react'

const VideoLabel = ({ duration, className }: { duration: number; className?: string }) => {
  const durationFormat = (durationMillis: number) => {
    const minutes = Math.floor(durationMillis / 60000)
    const seconds = Math.floor((durationMillis % 60000) / 1000)
    return `${minutes}:${String(seconds).padStart(2, '0')}`
  }

  if (!duration) {
    return
  }

  return (
    <div className={clsx(styles['video-container'], className)} data-cy="video-label">
      <Icon name="play" size={24} />
      <span className={styles['video-duration']} data-cy="video-label_duration">
        {durationFormat(duration)}
      </span>
    </div>
  )
}

export default VideoLabel
